import React from 'react';
import { Flex } from 'rebass';
import Frame from 'components/Frame';
import EditProfileForm from 'modules/Profile/components/EditProfileForm';

const EditProfile: React.FC<any> = (): JSX.Element => {
  return (
    <>
      <Frame>
        <Flex width="100%" flexDirection="column">
          <EditProfileForm />
        </Flex>
      </Frame>
    </>
  );
};

export default EditProfile;
